/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/labelassignmentfield/field/info/info_styles';



/* ========== ~~~~~~~~~~ EXPORT : FORM : FIELD : INFO ~~~~~~~~~~ ========== */
export default injectSheet(styles)((props) =>
	<div className={`info ${props.classes.info}`}>
    	{props.children}
    </div>
);
